<!-- Compiled at 2026-09-18T12:45:23.821Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<Orders-MainLayout
					[$formDirective]="$formDirective"
					[$disabled]="$disabled"
					[$ignoreValidations]="$ignoreValidations"
					[screenTitle]="'Vendor offers'"
					[isForExternalUser]=""
				>
					<ng-template
						data-content-area="top-right"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="top-right"
								data-defined-in="Orders.VendorOfferList"
							></div>
						</ng-container>
					</ng-template>

					<ng-template
						data-content-area="content"
						let-$scope="$scope"
						let-$formDirective="$formDirective"
						let-$disabled="$disabled"
					>
						<ng-container *lowgileScope="null; screen: this; let $scope">
							<div
								data-content-area="content"
								data-defined-in="Orders.VendorOfferList"
							>
								<lowgile-table
									#datatable_100
									[serverDataStore]="Orders.Db"
									[trackBy]="trackByAutomatic"
									[filter]="screen.filter"
									[entity]="Orders.VendorOffer"
									[columns]="_DataTableBlock_columns_100(screen)"
									[showSettings]="true"
									[userDefinedConfiguration]="undefined"
									[usePaging]="true"
									[pageSize]="20"
									[pageSizeOptions]="[10, 20, 50]"
									[useGlobalFilter]="true"
									[debouncingDelay]="250"
									[stickyHeader]="true"
									[additionalFindOptions]="_DataTableBlock_additionalFindOptions_100({ app, screen, $pathSegments, $disabled })"
									[additionalHeaderRows]="[]"
									[additionalFooterRows]="[]"
									[allClasses]="$Modules"
									[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
									[surroundingScope]="$scope"
									#$table_100="lowgileTable"
								>
									<ng-container [lowgile-column]="'offerId'">
										<th mat-header-cell *matHeaderCellDef>
											<span
												[innerHtml]="'Vendor request ID' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</th>
										<td
											mat-cell
											*matCellDef="let offer; let offerIndex = index"
											[attr.data-label]="'Vendor request ID'"
										>
											<ng-container
												*lowgileScope="offer; as: 'offer'; let $scope"
											>
												<ng-container
													*lowgileScope="offerIndex; as: 'offerIndex'; let $scope"
												>
													<a
														routerLink="/CustomerRequestView"
														[queryParams]="{ requestId: offer.requestId, offerId: offer.id }"
														routerLinkActive="is-current-link"
														target="_self"
													>
														<span
															[innerHtml]="offer.id | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</a>
												</ng-container>
											</ng-container>
										</td>
									</ng-container>
									<ng-container [lowgile-column]="('offerId') + '$$filter'">
										<th mat-header-cell *matHeaderCellDef></th>
									</ng-container>

									<ng-container [lowgile-column]="'requestId'">
										<th mat-header-cell *matHeaderCellDef>
											<span
												[innerHtml]="'Customer request ID' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</th>
										<td
											mat-cell
											*matCellDef="let offer; let offerIndex = index"
											[attr.data-label]="'Customer request ID'"
										>
											<ng-container
												*lowgileScope="offer; as: 'offer'; let $scope"
											>
												<ng-container
													*lowgileScope="offerIndex; as: 'offerIndex'; let $scope"
												>
													<a
														routerLink="/CustomerRequestView"
														[queryParams]="{ requestId: offer.requestId, offerId: offer.id }"
														routerLinkActive="is-current-link"
														target="_self"
													>
														<span
															[innerHtml]="offer.requestId | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</a>
												</ng-container>
											</ng-container>
										</td>
									</ng-container>
									<ng-container [lowgile-column]="('requestId') + '$$filter'">
										<th mat-header-cell *matHeaderCellDef></th>
									</ng-container>

									<ng-container [lowgile-column]="'name'">
										<th mat-header-cell *matHeaderCellDef>
											<span
												[innerHtml]="'Items' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</th>
										<td
											mat-cell
											*matCellDef="let offer; let offerIndex = index"
											[attr.data-label]="'Items'"
										>
											<ng-container
												*lowgileScope="offer; as: 'offer'; let $scope"
											>
												<ng-container
													*lowgileScope="offerIndex; as: 'offerIndex'; let $scope"
												>
													<span
														[innerHtml]="_DataTableColumnBlock_cellText_101({ app, screen, $pathSegments, $disabled, offer, offerIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</ng-container>
											</ng-container>
										</td>
									</ng-container>
									<ng-container [lowgile-column]="('name') + '$$filter'">
										<th mat-header-cell *matHeaderCellDef></th>
									</ng-container>

									<ng-container [lowgile-column]="'materials'">
										<th mat-header-cell *matHeaderCellDef>
											<span
												[innerHtml]="'Materials' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</th>
										<td
											mat-cell
											*matCellDef="let offer; let offerIndex = index"
											[attr.data-label]="'Materials'"
										>
											<ng-container
												*lowgileScope="offer; as: 'offer'; let $scope"
											>
												<ng-container
													*lowgileScope="offerIndex; as: 'offerIndex'; let $scope"
												>
													<span
														[innerHtml]="_DataTableColumnBlock_cellText_106({ app, screen, $pathSegments, $disabled, offer, offerIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</ng-container>
											</ng-container>
										</td>
									</ng-container>
									<ng-container [lowgile-column]="('materials') + '$$filter'">
										<th mat-header-cell *matHeaderCellDef></th>
									</ng-container>

									<ng-container [lowgile-column]="'vendor'">
										<th mat-header-cell *matHeaderCellDef>
											<span
												[innerHtml]="'Vendor' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</th>
										<td
											mat-cell
											*matCellDef="let offer; let offerIndex = index"
											[attr.data-label]="'Vendor'"
										>
											<ng-container
												*lowgileScope="offer; as: 'offer'; let $scope"
											>
												<ng-container
													*lowgileScope="offerIndex; as: 'offerIndex'; let $scope"
												>
													<span
														[innerHtml]="_DataTableColumnBlock_cellText_115({ app, screen, $pathSegments, $disabled, offer, offerIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</ng-container>
											</ng-container>
										</td>
									</ng-container>
									<ng-container [lowgile-column]="('vendor') + '$$filter'">
										<th mat-header-cell *matHeaderCellDef></th>
									</ng-container>

									<ng-container [lowgile-column]="'status'">
										<th mat-header-cell *matHeaderCellDef>
											<span
												[innerHtml]="'Vendor request status' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</th>
										<td
											mat-cell
											*matCellDef="let offer; let offerIndex = index"
											[attr.data-label]="'Vendor request status'"
										>
											<ng-container
												*lowgileScope="offer; as: 'offer'; let $scope"
											>
												<ng-container
													*lowgileScope="offerIndex; as: 'offerIndex'; let $scope"
												>
													<span
														[innerHtml]="_DataTableColumnBlock_cellText_105({ app, screen, $pathSegments, $disabled, offer, offerIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</ng-container>
											</ng-container>
										</td>
									</ng-container>
									<ng-container [lowgile-column]="('status') + '$$filter'">
										<th mat-header-cell *matHeaderCellDef></th>
									</ng-container>

									<ng-container [lowgile-column]="'request.status'">
										<th mat-header-cell *matHeaderCellDef>
											<span
												[innerHtml]="'Customer request status' | escapeHtml: 'none' | replaceNewlines: 'span'"
											></span>
										</th>
										<td
											mat-cell
											*matCellDef="let offer; let offerIndex = index"
											[attr.data-label]="'Customer request status'"
										>
											<ng-container
												*lowgileScope="offer; as: 'offer'; let $scope"
											>
												<ng-container
													*lowgileScope="offerIndex; as: 'offerIndex'; let $scope"
												>
													<span
														[innerHtml]="_DataTableColumnBlock_cellText_111({ app, screen, $pathSegments, $disabled, offer, offerIndex }) | escapeHtml: 'none' | replaceNewlines: 'span'"
													></span>
												</ng-container>
											</ng-container>
										</td>
									</ng-container>
									<ng-container
										[lowgile-column]="('request.status') + '$$filter'"
									>
										<th mat-header-cell *matHeaderCellDef></th>
									</ng-container>
								</lowgile-table>
							</div>
						</ng-container>
					</ng-template>
				</Orders-MainLayout>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
